import Vue from 'vue';
import App from "./App.vue";
import Firebase from 'firebase';

// Initialize Firebase
var config = {
apiKey: "AIzaSyB67sS9mME-iOXhq411-6iRSqTSbSCDpsY",
authDomain: "jjp-yasumi.firebaseapp.com",
databaseURL: "https://jjp-yasumi.firebaseio.com",
projectId: "jjp-yasumi",
storageBucket: "jjp-yasumi.appspot.com",
messagingSenderId: "633577102826"
};
Firebase.initializeApp(config);
console.log("init")

new Vue({
    el: '#app',
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/index.js